module.exports = __webpack_public_path__ + "img/3dd090f.jpg";